import * as React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useAuth } from 'module/auth/context/AuthContext';
import { AccountCircle } from '@mui/icons-material';
import { useHistory } from 'react-router-dom';
import { ROUTES } from 'module/navigation/enums/routes.enums';
import SettingsDialog from 'core/components/Modal/SettingsModal';
import Avatar from '@mui/material/Avatar';
import { userProfilesService, getImageUrl } from '../../../core/API/userProfiles';
import { useWorkplacesContext } from 'module/workplaces/context/WorkplacesContext';

export default function NavigationMenu() {
	const { user, logout } = useAuth();
	const { push, location } = useHistory();
	const { data } = useWorkplacesContext();

	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	const [profilePicture, setProfilePicture] = React.useState<string | null>(null);
	const [nickname, setNickname] = React.useState<string | null>(null);

	React.useEffect(() => {
		const fetchProfile = async () => {
			try {
				if (!user?.id) return;
				const profile = await userProfilesService.getUserProfile(user.id);
				if (profile.profilePictureName) {
					setProfilePicture(getImageUrl(profile.profilePictureName));
				}
				if (profile.nickname) {
					setNickname(profile.nickname);
				}
			} catch (error) {
				console.error('Failed to fetch profile picture:', error);
			}
		};
		fetchProfile();
	}, [user?.id]);

	const open = Boolean(anchorEl);

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	// Check if user has more than one workplace
	const hasMultipleWorkplaces = data?.items && data.items.length > 1;

	return (
		<div>
			<Button
				id="basic-button"
				style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
				startIcon={
					profilePicture ? (
						<Avatar 
							src={profilePicture} 
							alt={`${user?.firstName} ${user?.lastName}`}
							sx={{ width: 32, height: 32 }}
						/>
					) : (
						<AccountCircle style={{ fontSize: '2rem', color: "#446388" }} />
					)
				}
				aria-controls={open ? 'basic-menu' : undefined}
				aria-haspopup="true"
				aria-expanded={open ? 'true' : undefined}
				onClick={handleClick}
			>
				{nickname || `${user?.firstName} ${user?.lastName}`}
			</Button>
			<Menu
				id="basic-menu"
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				MenuListProps={{
					'aria-labelledby': 'basic-button',
				}}
				PaperProps={{
					sx: {
						minWidth: '200px',
					}
				}}
			>
				{hasMultipleWorkplaces && (
					<MenuItem
						onClick={() =>
							push({
								pathname: ROUTES.LOGIN,
								state: location.pathname,
							})
						}
					>
						Switch workplace
					</MenuItem>
				)}
				{/* <SettingsDialog /> */}
				<MenuItem onClick={logout}>Logout</MenuItem>
			</Menu>
		</div>
	);
}
